import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { BackLink } from '../views-components/BackLink';
import { AppHeader } from './AppHeader';
import { AppViewComponent } from './AppViewComponent';
import { useViewContainer } from './useViewContainer';
import { GuaranteeBanner } from '../views-components/GuaranteeBanner/GuaranteeBanner';
import { TrackWhen, useExperiment } from '../experiments/useExperiment';
import { ExperimentKeys } from '../experiments/ExperimentKeys';
import { Step } from '../views/Step';
import { ScrollToCta } from '../views-components/GuaranteeBanner/ScrollToCta';
import { useCurrentStep } from '../hooks/useCurrentStep';
import styled from 'styled-components';
import { devices } from '../styles/viewports.styles';
export const ViewContainerWrapper = styled.div.withConfig({
  displayName: "BasicViewContainer__ViewContainerWrapper",
  componentId: "sc-1aau5sd-0"
})(["display:grid;grid-template-columns:1.25rem 3.125rem auto 3.125rem 1.25rem;grid-template-rows:minmax(2.5rem,max-content) 0 auto minmax( 2.5rem,max-content );grid-template-areas:'left-gutter header header header right-gutter' 'left-gutter subheader subheader subheader right-gutter' 'left-gutter main main main right-gutter' 'left-gutter submain submain submain right-gutter';min-height:100vh;padding-top:0.5rem;max-width:32.5rem;margin:0 auto;", " @media ", "{max-width:37.5rem;}@media ", "{grid-template-columns:2.5rem 3.125rem auto 3.125rem 2.5rem;grid-template-rows:minmax(2.5rem,max-content) 0 auto minmax( 2.5rem,max-content );max-width:100vw;margin:0 auto;}"], props => props.theme.embedded && `grid-template-rows: 5rem 0 auto 5rem 5rem;`, devices.tablet, devices.desktop);
const BackButton = styled.div.withConfig({
  displayName: "BasicViewContainer__BackButton",
  componentId: "sc-1aau5sd-1"
})(["display:none;grid-template-rows:auto auto;grid-area:subheader;z-index:1;@media ", "{display:initial;}"], devices.desktop);
export const BasicViewContainer = () => {
  const {
    ViewComponent,
    viewContainerProps
  } = useViewContainer();
  const {
    isAssignedToVariant: isAssignedToVariantACQ117,
    parameter: acq117Parameter
  } = useExperiment(ExperimentKeys.ACQ117, TrackWhen.never);
  const {
    currentStep
  } = useCurrentStep();
  const shouldShowACQ117 = isAssignedToVariantACQ117() && currentStep === Step.LandingPage;

  if (!ViewComponent) {
    return null;
  }

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(ViewContainerWrapper, Object.assign({}, viewContainerProps, {
      children: [/*#__PURE__*/_jsx(AppHeader, {}), /*#__PURE__*/_jsx(BackButton, {
        className: "m-top-4",
        children: /*#__PURE__*/_jsx(BackLink, {})
      }), /*#__PURE__*/_jsx(AppViewComponent, {
        StepViewComponent: ViewComponent
      })]
    })), shouldShowACQ117 && /*#__PURE__*/_jsx(ScrollToCta, {
      acq117Parameter: acq117Parameter
    }), shouldShowACQ117 && /*#__PURE__*/_jsx(GuaranteeBanner, {})]
  });
};